import detectMobileDevice from 'is-mobile';
import React from 'react';
import styled from 'styled-components';

import { useTimer } from '../../hooks';
import { pad } from '../../utilities';

export default function Timer() {
  const isMobile = detectMobileDevice();
  const { start, stop, time } = useTimer();

  React.useEffect(() => {
    start();

    return () => {
      stop();
    };
  }, [start, stop]);

  return (
    <Time isMobile={isMobile}>
      {pad(time.minutes)} : {pad(time.seconds)}
    </Time>
  );
}

const Time = styled.div`
  position: absolute;
  display: flex;
  justify-content: flex-end;
  margin-top: -20px;
  margin-left: ${props => (props.isMobile ? '20px' : '30px')};
  margin-bottom: 0.25em;
  font-size: 12px;
  font-weight: 400;
  line-height: 19px;
  color: #9c9c9c;
`;
